import React from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { SimovsatActiveInactive } from '~/types';

interface ActiveInactiveCardProps {
  activeInactive: SimovsatActiveInactive;
}

const COLORS = {
  on: '#4CAF50', // Verde
  off: '#F44336', // Vermelho
};

export default function ActiveInactiveCard({ activeInactive }: ActiveInactiveCardProps) {
  const data = [
    { name: 'Desligado', value: activeInactive.off.count, percent: activeInactive.off.percent },
    { name: 'Ligado', value: activeInactive.on.count, percent: activeInactive.on.percent },
  ];

  const renderCustomLabel = (entry: any) => {
    return `${entry.percent.toFixed(1)}%`;
  };

  return (
    <Card style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 20 }}>
        <Typography variant='h6' style={{ fontWeight: 'bold', marginBottom: 20, textAlign: 'center' }}>
          ATIVO/INATIVO
        </Typography>
        <ResponsiveContainer width='100%' height={300}>
          <PieChart>
            <Pie
              data={data}
              cx='50%'
              cy='50%'
              innerRadius={60}
              outerRadius={100}
              paddingAngle={5}
              dataKey='value'
              label={renderCustomLabel}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={index === 0 ? COLORS.off : COLORS.on} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value: number, name: string, props: any) => [
                `${value} (${props.payload.percent.toFixed(1)}%)`,
                name,
              ]}
            />
            <Legend
              verticalAlign='bottom'
              height={36}
              formatter={(value, entry: any) => (
                <span style={{ color: entry.color }}>{value}</span>
              )}
            />
          </PieChart>
        </ResponsiveContainer>
        <div style={{ display: 'flex', gap: 20, marginTop: 10 }}>
          <div style={{ textAlign: 'center' }}>
            <Typography variant='body2' style={{ color: COLORS.off, fontWeight: 'bold' }}>
              Desligado: {activeInactive.off.count}
            </Typography>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Typography variant='body2' style={{ color: COLORS.on, fontWeight: 'bold' }}>
              Ligado: {activeInactive.on.count}
            </Typography>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
